import footerBadge from 'img/footer-badge.png'
import 'css/components/footer.css'

/* The mockups' footer social icons are 15px line SVGs stroked in currentColor
   inside a translucent disc -- see .social-links a in footer.css. They are
   inlined rather than imported as files because an <img> cannot inherit the
   footer's colour, which is what left staging showing the full-colour brand
   marks as two bright discs on the azure. */
const InstagramIcon = () => (
	<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
		<rect x="2" y="2" width="20" height="20" rx="5" />
		<circle cx="12" cy="12" r="4" />
		<circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
	</svg>
)

const LinkedInIcon = () => (
	<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
		<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z" />
		<rect x="2" y="9" width="4" height="12" />
		<circle cx="4" cy="4" r="2" />
	</svg>
)

export const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer-container">
				<div className="footer-left">
					<a href="/dashboard" className="footer-logo-link" aria-label="All For One, go to your dashboard">
						<img src={footerBadge} alt="All For One" className="footer-logo" />
					</a>
					<span className="footer-meta">
						<p className="footer-copy">&copy; {new Date().getFullYear()} All For One</p>
						<span className="footer-divider" aria-hidden="true"></span>
						{/* Destination given by Aspen 2026-11-05. The page is live on the
						    marketing site (verified HTTP 200, title "Privacy Policy - All
						    For One"), which supersedes the earlier note here that no
						    privacy page existed. Absolute URL on purpose: the policy lives
						    on the marketing site, not in this app. */}
						<a
							href="https://www.allforonelearn.com/privacy.html"
							className="footer-link"
							data-text="Privacy Policy"
							target="_blank"
							rel="noopener noreferrer"
						>Privacy Policy</a>
					</span>
				</div>
				<div className="footer-right">
					<p className="footer-questions">
						Questions?{' '}
						<a href="mailto:hey@allforonelearn.com" className="footer-link" data-text="Contact Us">Contact Us</a>
					</p>
					<div className="social-links">
						<a href="https://www.instagram.com/allforonelearn/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><InstagramIcon /></a>
						<a href="https://www.linkedin.com/company/all-for-one-afo/posts/?feedView=all" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><LinkedInIcon /></a>
					</div>
				</div>
			</div>
		</footer>
	)
}


export const StudentFooter = () => {
	return (
		<footer className="footer">
			<div className="footer-container">
				<div className="footer-left">
					<img src={footerBadge} alt="All For One" className="footer-logo" />
					<p className="footer-copy">&copy; {new Date().getFullYear()} All For One</p>
				</div>
			</div>
		</footer>
	)
}
